import { useCallback } from 'react';

import * as events from 'src/lib/events';
import { useErrorHandler, useTrackingEvent } from 'src/services';
import { useFreestyleToolsActions, useNotificationActions, useWorkspaceActions } from 'src/store';

export const useHandlers = (entity, onSavePrompt, onClosePrompt, generationTool) => {
  const notifications = useNotificationActions();
  const workspaceActions = useWorkspaceActions();
  const freestyleToolsActions = useFreestyleToolsActions();
  const handleError = useErrorHandler();
  const trackingEvents = useTrackingEvent();

  const handleSaveFreestyleTool = useCallback(async () => {
    try {
      const createdTool = await freestyleToolsActions.createFreestyleTool({
        tool: entity,
        workspaceId: entity.allWorkspaces ? null : workspaceActions.getCurrentWorkspaceId(),
      });
      if (createdTool) {
        notifications.displaySuccess('Prompt created');
        onSavePrompt(createdTool);
      }
    } catch (error) {
      handleError(error);
    }
  }, [freestyleToolsActions, workspaceActions, entity, notifications, onSavePrompt, handleError]);

  const handleEditFreestyleTool = useCallback(async () => {
    try {
      const editedTool = await freestyleToolsActions.updateFreestyleTool({
        id: freestyleToolsActions.getCurrentFreestyleTool().id,
        tool: entity,
      });
      freestyleToolsActions.updateFreestyleTools(editedTool);
      freestyleToolsActions.setCurrentFreestyleTool(null);

      trackingEvents(events.PROMPTS.promptUpdated, { page: events.EVENT_PAGE.prompts });
      notifications.displaySuccess('Prompt updated');

      onClosePrompt();
    } catch (error) {
      handleError(error);
    }
  }, [entity, freestyleToolsActions, handleError, notifications, onClosePrompt, trackingEvents]);

  const handleCloseSavePopup = useCallback(() => {
    freestyleToolsActions.clearNameErrorMessage();
    onClosePrompt();
  }, [onClosePrompt, freestyleToolsActions]);

  return {
    handleSaveFreestyleTool,
    handleCloseSavePopup,
    handleEditFreestyleTool,
  };
};
